// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1wQG0","modalFooterButton":"ModalNotes_modalFooterButton__3otwg"};